<div class="container" *ngIf="loadingHome">
  <div class="wrapper">
    <div class="mb-20" style="display: flex; justify-content: space-between; width: 100%;">
      <div class="mb-20" style="width: 100%; max-width: 480px; min-width: 0;">
        <ion-skeleton-text animated style="
            width: min(100%, 318px);
            height: 25px;
            border-radius: 12px;
            margin-bottom: 23px;
          "></ion-skeleton-text>
        <ion-skeleton-text animated style="
            width: min(100%, 467px);
            height: 96px;
            border-radius: 12px;
            margin-bottom: 40px;
          "></ion-skeleton-text>

        <ion-skeleton-text animated style="
            width: min(100%, 219px);
            height: 24px;
            border-radius: 12px;
            margin-bottom: 3.5px;
          "></ion-skeleton-text>
        <ion-skeleton-text animated style="
            width: min(100%, 475px);
            height: 96px;
            border-radius: 12px;
            margin-bottom: 48px;
          "></ion-skeleton-text>

        <ion-skeleton-text animated style="
            width: min(100%, 219px);
            height: 24px;
            border-radius: 12px;
            margin-bottom: 3.5px;
          "></ion-skeleton-text>
        <ion-skeleton-text animated style="
            width: min(100%, 475px);
            height: 96px;
            border-radius: 12px;
            margin-bottom: 24px;
          "></ion-skeleton-text>

        <ion-item lines="none" style="--min-height: 20px">
          <ion-skeleton-text animated style="
              width: min(100%, 134px);
              height: 20px;
              border-radius: 12px;
              margin-bottom: 3.5px;
              margin-right: 8px;
            "></ion-skeleton-text>
          <ion-skeleton-text animated style="
              width: min(100%, 134px);
              height: 20px;
              border-radius: 12px;
              margin-bottom: 3.5px;
            "></ion-skeleton-text>
        </ion-item>
        <ion-item lines="none" style="--min-height: 20px">
          <ion-skeleton-text animated style="
              width: min(100%, 134px);
              height: 20px;
              border-radius: 12px;
              margin-bottom: 3.5px;
              margin-right: 8px;
            "></ion-skeleton-text>
          <ion-skeleton-text animated style="
              width: min(100%, 134px);
              height: 20px;
              border-radius: 12px;
              margin-bottom: 3.5px;
            "></ion-skeleton-text>
        </ion-item>
        <ion-item lines="none" style="--min-height: 20px">
          <ion-skeleton-text animated style="
              width: min(100%, 134px);
              height: 20px;
              border-radius: 12px;
              margin-bottom: 3.5px;
              margin-right: 8px;
            "></ion-skeleton-text>
          <ion-skeleton-text animated style="
              width: min(100%, 134px);
              height: 20px;
              border-radius: 12px;
              margin-bottom: 3.5px;
            "></ion-skeleton-text>
        </ion-item>

        <ion-skeleton-text animated style="
            width: min(100%, 320px);
            height: 40px;
            border-radius: 12px;
            margin-top: 25px;
            justify-self: center;
          "></ion-skeleton-text>
      </div>
    </div>
  </div>
</div>

<div class="container" *ngIf="!loadingHome">
  <div class="wrapper">
    <div class="mb-20">
      <div class="hero-header">
        <div class="title-section">
          <div class="title">Solicitud de Pensión por Vejez</div>
          <p *ngIf="mostrarTextoHeroIniciarTramite" class="div-text hero-intro-text">
            Estás por presentar tu solicitud de trámite de pensión, solo debes seguir los pasos para completar el
            formulario. Esto será <strong>rápido, fácil y seguro.</strong>
          </p>
          <p *ngIf="mostrarTextoHeroTramitePresentado" class="div-text hero-intro-text">
            Enviamos un correo a {{ correoClienteHero }} el día {{ fechaIngresoTramiteHero }}, con la copia adjunta de
            tu
            Solicitud de Pensión por Vejez.
          </p>
        </div>

        <!-- Card duración tramite -->
        <div class="info-card-timer" *ngIf="statusInfo">
          <div class="hero-header__inner">
            <div class="info-card-timer__inner">
              <div class="info-card-timer__column">
                <p id="estado-solicitud-label" class="info-card-timer__label">Estado de la solicitud</p>
                <p [attr.aria-label]="'Estado de la solicitud: ' + statusInfo.estadoTramite">
                  <span [ngClass]="claseBadgeEstadoTramite">
                    {{ statusInfo.estadoTramite }}
                  </span>
                </p>
              </div>
              <div class="info-card-timer__column" *ngIf="
                  numeroSolicitudTramite &&
                  (statusInfo === labelStatus.TRAMITE_EN_CURSO || statusInfo === labelStatus.TRAMITE_FINALIZADO)
                ">
                <p id="numero-solicitud-label" class="info-card-timer__label">Nº de solicitud</p>
                <p class="info-card-timer__value" [attr.aria-label]="'Número de solicitud: ' + numeroSolicitudTramite">
                  <span class="info-card-timer__value--highlight">{{ numeroSolicitudTramite }}</span>
                </p>
              </div>
              <div class="info-card-timer__column"
                *ngIf="statusInfo === labelStatus.TRAMITE_EN_CURSO || statusInfo === labelStatus.TRAMITE_FINALIZADO">
                <p id="fecha-presentacion-label" class="info-card-timer__label">Fecha de presentación</p>
                <p class="info-card-timer__value"
                  [attr.aria-label]="'Fecha de presentación: ' + fechaPresentacionTramite">
                  <span class="info-card-timer__value--highlight">{{ fechaPresentacionTramite }}</span>
                </p>
              </div>
              <div class="info-card-timer__column" *ngIf="statusInfo === labelStatus.INICIAR_TRAMITE">
                <p id="duracion-label" class="info-card-timer__label">Duración</p>
                <p class="info-card-timer__value info-card-timer__value--nowrap"
                  [attr.aria-label]="'Duración: ' + statusInfo.duracion">
                  <ion-icon name="time-outline" class="icon-mr" aria-hidden="true"></ion-icon>
                  {{ statusInfo.duracion }}
                </p>
              </div>
              <div class="info-card-timer__column">
                <p id="plazo-revision-label" class="info-card-timer__label">Plazo de revisión</p>
                <p class="info-card-timer__value" [attr.aria-label]="'Plazo de revisión: ' + statusInfo.plazoRevision">
                  <span class="info-card-timer__value--highlight">{{ statusInfo.plazoRevision }}</span>
                </p>
              </div>
              <div class="info-card-timer__actions" *ngIf="statusInfo === labelStatus.INICIAR_TRAMITE">
                <button type="button" class="info-card-timer__button" aria-label="Revisa los pasos"
                  title="Revisa los pasos" (click)="openModalPasosTramitePension()">
                  Revisa los pasos
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
      <!-- Izquierda: banner amarillo + Requisitos. Derecha: menú Revisa (alineado a la derecha de ambos) -->
      <div class="main-with-sidebar">
        <div class="main-with-sidebar__left">
          <div class="modal-reforma-info-box hero-benefits hero-benefits--above-requisitos"
            *ngIf="statusInfo === labelStatus.INICIAR_TRAMITE">
            <div class="hero-benefits__content">
              <div class="icon-container">
                <icon-info-circle-tramite aria-hidden="true"></icon-info-circle-tramite>
              </div>
              <p class="hero-benefits__text">
                ¿Sabías que hay beneficios que podrían aumentar tu pensión?
              </p>
            </div>
            <button type="button" class="hero-benefits__button"
              aria-label="Conoce más sobre beneficios para aumentar tu pensión"
              (click)="openModalReformaTramitePension(modalBeneficiosReforma)">
              Conoce más
            </button>
          </div>

          <div class="item-text">
            <ng-container *ngIf="
              statusFlow !== tramitePensionFlowsEnum.TRAMITE_FINALIZADO;
              else applicationSubmitted
            ">

              <div class="tramite-requisitos-card">
                <p id="requisitos" class="requirements-title">
                  ¿Qué necesitas para realizar tu solicitud?
                </p>
                <p class="requirements-intro">
                  Antes de comenzar, revisa si este canal es el adecuado para tu caso o si necesitas atención
                  personalizada.
                </p>

                <ul class="requirements-list">
                  <li class="requirements-item">
                    <span class="requirements-icon">
                      <icon-check-circle-tramite></icon-check-circle-tramite>
                    </span>
                    <div class="requirements-content">
                      <p class="requirements-item__title">
                        Cumplir la edad legal
                      </p>
                      <p class="requirements-item__text">
                        Las mujeres deben tener 60 años y los hombres 65 años. Puedes iniciar el trámite hasta 6 meses
                        antes de la edad legal.
                      </p>
                    </div>
                  </li>

                  <li class="requirements-item">
                    <span class="requirements-icon">
                      <icon-check-circle-tramite></icon-check-circle-tramite>
                    </span>
                    <div class="requirements-content">
                      <p class="requirements-item__title">
                        Tener actualizados tus datos de contacto
                      </p>
                      <p class="requirements-item__text">
                        Puedes modificar tu información en
                        <button type="button" class="link link-button" (click)="goToYourDataModal()"
                          aria-label="Ir a Tus datos">
                          <strong>Tus datos</strong>
                        </button>.
                      </p>
                    </div>
                  </li>

                  <li class="requirements-item">
                    <span class="requirements-icon">
                      <icon-check-circle-tramite></icon-check-circle-tramite>
                    </span>
                    <div class="requirements-content">
                      <p class="requirements-item__title">
                        Tener actualizados los datos de tus beneficiarios
                      </p>
                      <p class="requirements-item__text">
                        Los beneficiarios hijos deben ser solteros y menores de 24 años. Puedes modificar en
                        <button type="button" class="link link-button" (click)="goToBeneficiariesModal()"
                          aria-label="Ir a Actualizar tus beneficiarios">
                          <strong>Actualizar tus beneficiarios</strong>
                        </button>.
                        <button type="button" class="beneficiario-tooltip-trigger" Tooltip-Info
                          aria-label="¿Qué es un beneficiario?" [tooltip]="textoTooltipBeneficiario"
                          [className]="'pensionados-tooltip-surface'">
                          <icon-info-circle-tramite aria-hidden="true"></icon-info-circle-tramite>
                        </button>
                      </p>
                    </div>
                  </li>

                  <li class="requirements-item">
                    <span class="requirements-icon">
                      <icon-check-circle-tramite></icon-check-circle-tramite>
                    </span>
                    <div class="requirements-content">
                      <p class="requirements-item__title">
                        Tener una copia de tu cédula de identidad y certificados, según sea tu caso.
                      </p>
                      <div class="requirements-item__text">
                        <ul class="requirements-cert-list">
                          <li>Certificado de Nacimiento.</li>
                          <li>Certificado de Matrimonio, si corresponde.</li>
                          <li>Certificado de Nacimiento del Cónyuge, si corresponde.</li>
                          <li>Certificado de Unión Civil, si corresponde.</li>
                        </ul>
                        <p class="requirements-item__text">
                          <strong>¿Te faltan documentos?</strong> Puedes descargarlos en
                          <a class="link" (click)="abrirRegistroCivil($event)" rel="noopener noreferrer"
                            aria-label="Ir a www.registrocivil.cl, se abre en una nueva pestaña">
                            www.registrocivil.cl
                            <ion-icon name="open-outline" class="external-link-icon" aria-hidden="true"></ion-icon>
                          </a>
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>

                <div class="requirements-warning">
                  <span class="requirements-warning__icon">
                    <icon-warning-tramite></icon-warning-tramite>
                  </span>
                  <div class="requirements-warning__content">
                    <div class="requirements-warning__header">
                      <p id="tramite" class="requirements-warning__text">
                        <strong>Este trámite no considera:</strong>
                      </p>
                      <ul class="requirements-warning__list">
                        <li>Beneficiarios con algún tipo de invalidez.</li>
                        <li>Ahorros voluntarios en otras AFP o instituciones financieras que quieras sumar.</li>
                        <li>
                          Si eres o fuiste empleado del sector público.
                          <button type="button" class="beneficiario-tooltip-trigger" Tooltip-Info
                            aria-label="¿Qué es un empleado del sector público?" [tooltip]="textoTooltipSectorPublico"
                            [className]="'pensionados-tooltip-surface'">
                            <icon-info-circle-tramite aria-hidden="true"></icon-info-circle-tramite>
                          </button>
                        </li>
                        <li>Montos en Ahorro Previsional Voluntario Colectivo - APVC</li>
                      </ul>
                    </div>
                    <div class="requirements-warning__footer">
                      <p class="requirements-warning__text">
                        <strong>¿Por qué no se consideran estos casos?</strong> Porque requieren un análisis especial de
                        nuestros ejecutivos, para asegurar que no pierdas ningún beneficio legal.
                      </p>
                      <p class="requirements-footer">
                        Si te encuentras en alguna de estas situaciones, te sugerimos agendar una
                        <button type="button" class="link link-button" aria-label="Agendar Video Atención"
                          (click)="goToVideoAtencion()">
                          <strong>Video Atención</strong>
                        </button>
                        para recibir orientación personalizada.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <fieldset id="confirmacion" class="confirmacion-card">
                <legend id="confirmacion-title" class="confirmacion-card__title">Para continuar, por favor confirma lo
                  siguiente:</legend>
                <div class="info-check confirmacion-card__check">
                  <ion-item lines="none" class="info-check__item">
                    <ion-checkbox slot="start" labelPlacement="end" [(ngModel)]="checkNoSoyEmpleadoPublico">
                      <ion-label class="label-check">
                        He leído con atención y confirmo que <span class="label-check__emphasis">NO</span> soy empleado
                        del sector público.
                      </ion-label>
                    </ion-checkbox>
                  </ion-item>
                </div>
                <div class="info-check confirmacion-card__check">
                  <ion-item lines="none" class="info-check__item">
                    <ion-checkbox slot="start" labelPlacement="end" [(ngModel)]="checkNoSumaAhorrosVoluntarios">
                      <ion-label class="label-check">
                        Confirmo que <span class="label-check__emphasis">NO</span> sumaré ahorros voluntarios de otras
                        AFP o instituciones financieras.
                      </ion-label>
                    </ion-checkbox>
                  </ion-item>
                </div>
                <div class="info-check confirmacion-card__check">
                  <ion-item lines="none" class="info-check__item" *ngIf="showBonoCheck">
                    <ion-checkbox
                      slot="start"
                      labelPlacement="end"
                      [checked]="checkBonoAmortizable"
                      (click)="openModalBonoAmortizable($event)">
                      <ion-label class="label-check">
                        Confirmo que revisé la información sobre
                        <button
                          type="button"
                          class="label-check__link"
                          (click)="openModalBonoAmortizable($event)">
                          Bono Amortizable
                        </button>.
                      </ion-label>
                    </ion-checkbox>
                  </ion-item>
                </div>
              </fieldset>

              <div class="confirmacion-card__actions">
                <button *ngIf="$any(statusFlow) !== tramitePensionFlowsEnum.TRAMITE_FINALIZADO"
                  class="primary-button primary-button--tramite" [attr.aria-label]="btnText" (click)="iniciarTramite()"
                  [disabled]="!checkNoSoyEmpleadoPublico || !checkNoSumaAhorrosVoluntarios || !checkBonoAmortizable || loading">
                  {{ btnText }}
                  <ion-spinner name="crescent" slot="end" *ngIf="loading" color="light">
                  </ion-spinner>
                </button>
              </div>
            </ng-container>

            <!-- Trámite en curso o presentado -->
            <ng-template #applicationSubmitted>
              <div class="tramite-presentado-card">
                <h2 id="que-viene-ahora" class="tramite-presentado-card__title">¿Qué viene ahora?</h2>
                <p class="tramite-presentado-card__text">
                  Nos contactaremos contigo por correo dentro de 10 días para informar sobre el resultado de tu
                  solicitud, próximos pasos e información relevante del trámite de Pensión por Vejez.
                </p>

                <div class="tramite-presentado-card__pgu importante-PGU">
                  <div class="importante-PGU__header">
                    <div class="icon-container importante-PGU-icon">
                      <ion-icon class="i-info-fill-2" aria-hidden="true"></ion-icon>
                    </div>
                    <p class="importante-PGU-title">Importante: Pensión Garantizada Universal (PGU)</p>
                  </div>
                  <p class="importante-PGU-description">
                    Si seleccionaste que solicitarás PGU, debes realizar el trámite directamente en el sitio web de
                    <a href="https://mi.chileatiende.gob.cl/tramites/sibs" target="_blank" rel="noopener noreferrer"
                      aria-label="Ir a ChileAtiende, se abre en una nueva pestaña">
                      ChileAtiende
                    </a>
                    <ion-icon name="open-outline" class="external-link-icon" aria-hidden="true"></ion-icon>
                  </p>
                </div>

                <div class="tramite-presentado-card__actions" *ngIf="mostrarBotonEstado">
                  <button type="button" class="primary-button primary-button--tramite"
                    aria-label="Ir a estado de trámite" (click)="goToEstadoTramite()">
                    Ir a estado de trámite
                  </button>
                </div>
              </div>
            </ng-template>
          </div>
        </div>

        <div class="main-with-sidebar__nav">
          <p class="support-card-heading">Te acompañamos</p>
          <div class="support-card">
            <p class="support-card__text">
              Si tienes dudas en cualquier momento de la solicitud, nuestros ejecutivos están listos para ayudarte.
            </p>
            <ul class="support-card__links">
              <li>
                <button type="button" class="support-card__link-button" aria-label="Agenda Video Atención"
                  (click)="goToVideoAtencion()">
                  Agenda Video Atención
                </button>
              </li>
              <li>
                <a class="support-card__link" href="tel:6006600900" aria-label="Llámanos al 600 6600 900">
                  Llámanos al 600 6600 900
                </a>
              </li>
              <li>
                <a class="support-card__link"
                  href="https://capitalplay.afpcapital.cl/educacion/tramite-pension-paso-a-paso" target="_blank"
                  rel="noopener noreferrer" aria-label="Revisa etapas del trámite, se abre en una nueva pestaña">
                  Revisa etapas del trámite
                  <ion-icon name="open-outline" class="external-link-icon external-link-icon--black"
                    aria-hidden="true"></ion-icon>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>